export const cubeProCountMeasure = "customers_view.pro_count";

export const cubeProLoyaltyJoinedAt = "customers_view.loyalty_joined_at";

export const cubeProRegionDimension = "customers_view.region";

export const cubeProIsProMember = "customers_view.is_pro";

export const cubeProMonthDataKey = "";
